import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import AuthShell from "../components/AuthShell";
import CampoPassword from "../components/CampoPassword";
import { verificarIdentidadAPI, restablecerPasswordAPI } from "../api/authAPI";

export default function RestablecerPassword() {
  const navigate = useNavigate();

  const [paso, setPaso] = useState(1); // 1 = verificar identidad, 2 = nueva contraseña
  const [enviando, setEnviando] = useState(false);
  const [tokenReset, setTokenReset] = useState(null);

  const [identificacion, setIdentificacion] = useState("");
  const [numeroContrato, setNumeroContrato] = useState("");
  const [nuevaPassword, setNuevaPassword] = useState("");
  const [confirmarPassword, setConfirmarPassword] = useState("");

  async function manejarPaso1(e) {
    e.preventDefault();
    setEnviando(true);
    try {
      const { token, mensaje } = await verificarIdentidadAPI(identificacion, numeroContrato);
      setTokenReset(token);
      setPaso(2);
      Swal.fire({ icon: "success", title: "Identidad verificada", text: mensaje, confirmButtonColor: "#1a3a5c" });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "No pudimos verificarte",
        text: error?.response?.data?.error || "Revisa tu identificación y número de contrato.",
        confirmButtonColor: "#1a3a5c",
      });
    } finally {
      setEnviando(false);
    }
  }

  async function manejarPaso2(e) {
    e.preventDefault();

    if (nuevaPassword !== confirmarPassword) {
      Swal.fire({ icon: "warning", title: "Las contraseñas no coinciden", confirmButtonColor: "#1a3a5c" });
      return;
    }

    setEnviando(true);
    try {
      await restablecerPasswordAPI(tokenReset, nuevaPassword);
      Swal.fire({
        icon: "success",
        title: "Contraseña actualizada",
        text: "Ya puedes iniciar sesión con tu nueva contraseña.",
        confirmButtonColor: "#1a3a5c",
      }).then(() => navigate("/login"));
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "No se pudo actualizar",
        text: error?.response?.data?.error || "El enlace pudo haber expirado, intenta de nuevo.",
        confirmButtonColor: "#1a3a5c",
      });
    } finally {
      setEnviando(false);
    }
  }

  return (
    <AuthShell
      kicker="Recuperar acceso"
      titulo="Restablecer contraseña"
      texto="Verificamos tu identidad con tu número de identificación y tu número de contrato. No necesitas correo."
      extra={
        <ol className="auth-pasos">
          <li><b>1</b><span>Verifica tu identidad.</span></li>
          <li><b>2</b><span>Define una nueva contraseña.</span></li>
        </ol>
      }
      estrecha
    >
      <div className="d-flex gap-2 mb-3" aria-hidden="true">
        <div style={{ flex: 1, height: 4, borderRadius: 4, background: "#2d5986" }} />
        <div style={{ flex: 1, height: 4, borderRadius: 4, background: paso === 2 ? "#2d5986" : "#e3e8ef" }} />
      </div>
      <h2>{paso === 1 ? "Verifica tu identidad" : "Nueva contraseña"}</h2>
      <div className="auth-sub">
        {paso === 1
          ? "Ingresa tu identificación y tu número de contrato."
          : "Identidad verificada. Define tu nueva contraseña."}
      </div>

      {paso === 1 && (
        <Form onSubmit={manejarPaso1}>
          <Form.Group className="mb-3" controlId="rp-identificacion">
            <Form.Label>Número de identificación</Form.Label>
            <Form.Control
              type="text"
              inputMode="numeric"
              value={identificacion}
              onChange={(e) => setIdentificacion(e.target.value)}
              required
              autoFocus
            />
          </Form.Group>

          <Form.Group className="mb-4" controlId="rp-contrato">
            <Form.Label>Número de contrato</Form.Label>
            <Form.Control
              type="text"
              value={numeroContrato}
              onChange={(e) => setNumeroContrato(e.target.value)}
              required
            />
          </Form.Group>

          <Button type="submit" className="w-100 btn-ps auth-btn" disabled={enviando}>
            {enviando ? "Verificando..." : "Verificar identidad"}
          </Button>
        </Form>
      )}

      {paso === 2 && (
        <Form onSubmit={manejarPaso2}>
          <Form.Group className="mb-3" controlId="rp-nueva">
            <Form.Label>Nueva contraseña</Form.Label>
            <CampoPassword
              value={nuevaPassword}
              onChange={(e) => setNuevaPassword(e.target.value)}
              autoComplete="new-password"
              placeholder="Mínimo 6 caracteres"
              minLength={6}
              required
              autoFocus
            />
          </Form.Group>

          <Form.Group className="mb-4" controlId="rp-confirmar">
            <Form.Label>Confirmar contraseña</Form.Label>
            <CampoPassword
              value={confirmarPassword}
              onChange={(e) => setConfirmarPassword(e.target.value)}
              autoComplete="new-password"
              minLength={6}
              isInvalid={confirmarPassword.length > 0 && confirmarPassword !== nuevaPassword}
              required
            />
          </Form.Group>

          <Button type="submit" className="w-100 btn-ps auth-btn" disabled={enviando}>
            {enviando ? "Guardando..." : "Guardar nueva contraseña"}
          </Button>
        </Form>
      )}

      <div className="text-center mt-3">
        <Link to="/login" className="auth-link">← Volver a iniciar sesión</Link>
      </div>
    </AuthShell>
  );
}
